var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutopilotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_425_22301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5921 13.2778H3.19831M5.59492 9H2M7.5921 4.72222H3.59774M13.9831 2L8.71337 9.18278C8.48012 9.5007 8.3635 9.65966 8.36855 9.79219C8.37295 9.90757 8.42978 10.0151 8.52366 10.0856C8.6315 10.1667 8.83214 10.1667 9.23342 10.1667H13.1842L12.3853 16L17.655 8.81722C17.8883 8.4993 18.0049 8.34034 17.9998 8.20781C17.9954 8.09243 17.9386 7.98491 17.8447 7.91436C17.7369 7.83333 17.5363 7.83333 17.135 7.83333H13.1842L13.9831 2Z",
    stroke: "url(#paint0_linear_425_22301)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_425_22301",
    x: 0.300195,
    y: 0.299951,
    width: 19.3996,
    height: 17.4001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_425_22301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_425_22301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_22301",
    x1: 1,
    y1: 9,
    x2: 18,
    y2: 8.99948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524921,
    stopColor: "#E8236F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#827EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1008EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopilotIcon);
export default __webpack_public_path__ + "static/media/autopilot_icon.f9a47c931660a9b3bf780b3a3783aec4.svg";
export { ForwardRef as ReactComponent };